import { createStyles } from '@mui/styles';
import { APTheme } from "../../../../core/TenantProvider/tenants";

export default (theme: APTheme) =>
  createStyles(
    (() => {
      return {
        root: {
          display: "flex",
          justifyContent: "center",
          "& > * + *": {
            marginLeft: theme.spacing(2),
          },
        },
      };
    })()
  );
